import { useEffect } from "react";
import { trackPhoneConversion } from "@/lib/gtag";

// Fires a Google Ads conversion whenever any tel: link is clicked, anywhere.
export const ConversionListeners = () => {
  useEffect(() => {
    const handler = (e) => {
      const link = e.target.closest && e.target.closest('a[href^="tel:"]');
      if (link) trackPhoneConversion();
    };
    document.addEventListener("click", handler, true);
    return () => document.removeEventListener("click", handler, true);
  }, []);
  return null;
};
